(function(angular){
	'use strict';
	
	angular
		.module('localRealEstateModule')
		.controller('FeaturedLocalProperties', [
			FeaturedLocalPropertiesFunction
		]);
	
	function FeaturedLocalPropertiesFunction(){
		var featuredLocalProperties = this;

		featuredLocalProperties.properties = globalConfig.propertiesToFeature;
	}
})(window.angular);